export const goats = [
    "Anglo-Nubian",
    "Angora",
    "British Alpine",
    "Saanen",
    "Toggenburg"
]